import React from "react";
import LegalLayout, { Section } from "../Legal/LegalLayout";
import LEGAL from "../Legal/legalIdentity";

/**
 * Condiciones de Uso — página pública (/terms).
 * URL usada como "Condiciones del servicio" en la revisión de la app de Meta.
 */
const TermsOfUse = () => {
  return (
    <LegalLayout
      title="Condiciones de Uso"
      intro={`Estas Condiciones de Uso regulan el acceso y uso del servicio ${LEGAL.brand}, operado por ${LEGAL.operator} (${LEGAL.tradeName}), RUC ${LEGAL.ruc}. Al crear una cuenta o utilizar la Plataforma, usted acepta estas condiciones.`}
    >
      <Section id="aceptacion" title="1. Aceptación">
        <p>
          Al registrarse o utilizar {LEGAL.brand} (la «Plataforma»), usted declara haber
          leído y aceptado estas Condiciones de Uso y la{" "}
          <a href="/privacy">Política de Privacidad</a>. Si no está de acuerdo, no debe
          utilizar el servicio.
        </p>
      </Section>

      <Section id="servicio" title="2. Descripción del servicio">
        <p>
          {LEGAL.brand} es una plataforma de atención y mensajería omnicanal que permite a
          las empresas conectar canales como WhatsApp, Facebook Messenger e Instagram para
          recibir, responder y organizar conversaciones, así como automatizar flujos y
          gestionar equipos de agentes.
        </p>
      </Section>

      <Section id="cuenta" title="3. Cuenta y registro">
        <p>
          El Usuario es responsable de la veracidad de los datos de registro, de mantener la
          confidencialidad de sus credenciales y de toda actividad realizada bajo su cuenta.
          Debe notificarnos de inmediato cualquier uso no autorizado.
        </p>
      </Section>

      <Section id="planes" title="4. Prueba gratuita, planes y pagos">
        <p>
          La Plataforma puede ofrecer un período de prueba y distintos planes. Las
          características, límites y precios de cada plan se informan al momento de la
          contratación. La falta de pago puede derivar en la suspensión o cancelación del
          servicio.
        </p>
      </Section>

      <Section id="uso-aceptable" title="5. Uso aceptable">
        <p>El Usuario se compromete a NO utilizar la Plataforma para:</p>
        <ul>
          <li>Enviar spam, mensajes masivos no solicitados o comunicaciones sin el consentimiento del destinatario.</li>
          <li>Difundir contenido ilegal, fraudulento, difamatorio, o que infrinja derechos de terceros.</li>
          <li>Distribuir malware o intentar vulnerar la seguridad de la Plataforma o de terceros.</li>
          <li>Infringir las políticas de WhatsApp, Meta u otras plataformas integradas.</li>
        </ul>
      </Section>

      <Section id="integraciones" title="6. Integraciones de terceros (Meta / WhatsApp)">
        <p>
          El uso de canales de Meta (WhatsApp Business, Messenger, Instagram) está sujeto a
          las condiciones y políticas de Meta. El Usuario es el único responsable de sus
          cuentas en dichas plataformas, de obtener los permisos necesarios y del contenido
          que envía. {LEGAL.brand} actúa como herramienta técnica para conectar dichos canales
          y no se responsabiliza por decisiones, suspensiones o bloqueos aplicados por Meta a
          las cuentas del Usuario.
        </p>
      </Section>

      <Section id="contenido" title="7. Contenido del Usuario">
        <p>
          El contenido de las conversaciones y los datos gestionados pertenecen al Usuario y a
          sus contactos. El Usuario garantiza contar con las autorizaciones necesarias para
          procesarlos y es responsable de su uso conforme a la ley.
        </p>
      </Section>

      <Section id="propiedad" title="8. Propiedad intelectual">
        <p>
          El software, la marca, los diseños y demás elementos de la Plataforma son propiedad
          del operador o de sus licenciantes. No se otorga al Usuario ningún derecho distinto
          del uso del servicio conforme a estas condiciones.
        </p>
      </Section>

      <Section id="disponibilidad" title="9. Disponibilidad y soporte">
        <p>
          Procuramos mantener la Plataforma disponible de forma continua, pero pueden existir
          interrupciones por mantenimiento, causas de fuerza mayor o dependencias de terceros
          (por ejemplo, las APIs de Meta). Brindamos soporte por los canales indicados en la
          sección de contacto.
        </p>
      </Section>

      <Section id="garantias" title="10. Exclusión de garantías">
        <p>
          La Plataforma se ofrece «tal cual» y «según disponibilidad». En la máxima medida
          permitida por la ley, no otorgamos garantías de que el servicio sea ininterrumpido
          o libre de errores.
        </p>
      </Section>

      <Section id="responsabilidad" title="11. Limitación de responsabilidad">
        <p>
          En la máxima medida permitida por la ley, el operador no será responsable por daños
          indirectos, lucro cesante o pérdida de datos derivados del uso o la imposibilidad de
          uso de la Plataforma, ni por acciones de plataformas de terceros.
        </p>
      </Section>

      <Section id="terminacion" title="12. Suspensión y terminación">
        <p>
          Podemos suspender o cancelar cuentas que incumplan estas condiciones o las políticas
          de las plataformas integradas. El Usuario puede cancelar su cuenta en cualquier
          momento; la eliminación de datos se rige por la Política de Privacidad.
        </p>
      </Section>

      <Section id="indemnizacion" title="13. Indemnización">
        <p>
          El Usuario se compromete a mantener indemne al operador frente a reclamos de terceros
          derivados del uso indebido de la Plataforma o del incumplimiento de estas condiciones
          o de la normativa aplicable.
        </p>
      </Section>

      <Section id="modificaciones" title="14. Modificaciones">
        <p>
          Podemos modificar el servicio o estas condiciones. Publicaremos la versión vigente en
          esta página con su fecha de actualización. El uso continuado implica la aceptación de
          los cambios.
        </p>
      </Section>

      <Section id="ley" title="15. Ley aplicable y jurisdicción">
        <p>
          Estas condiciones se rigen por las leyes de la República del {LEGAL.country}.
          Cualquier controversia se someterá a los jueces y tribunales de {LEGAL.city}, salvo
          norma imperativa en contrario.
        </p>
      </Section>

      <Section id="contacto" title="16. Contacto">
        <p>
          Para consultas sobre estas condiciones, escriba a{" "}
          <a href={`mailto:${LEGAL.email}`}>{LEGAL.email}</a>.
        </p>
      </Section>
    </LegalLayout>
  );
};

export default TermsOfUse;
